import {
  InputProps,
  Setting
} from 'view/components/theme-settings/theme-setting-input';
import { FileInputZone } from 'view/components/file-input';

export function getMultiImageInput(setting: Setting): InputProps {
  return {
    input: FileInputZone,
    inputProps: {
      settingKey: setting.key,
      category: 'style',
      type: 'multi-image',
      multiple: true,
      themeFile: true,
      value: setting?.value
    }
  };
}
